import React from 'react';
import styles from './Footer.module.css';

import {Typography} from "@mui/material";
import {useNavigate} from "react-router-dom";

const SignUpBannerFooter: React.FC = () => {
  const navigate = useNavigate();

  return <>
    <section id="BannerFooter" className={styles.BannerFooter}>
      <div className={styles.BannerFooterRow}>
        <Typography variant="h2">Sign up to start playing SPARX</Typography>
        <button className={'PrimaryButton WhiteButton'} style={{padding: "16px 50px", margin: "40px 0"}} onClick={() => navigate("/register")}>Sign up</button>
      </div>
    </section>
  </>;
};

export default SignUpBannerFooter;
